module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Typ pola"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Wybierz pole"
    },
    model: {
      value: (_vm.form.field_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "field_type", $$v)
      },
      expression: "form.field_type"
    }
  }, _vm._l((_vm.charFieldTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41fbc408"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/forms/CharField.vue
// module id = 744
// module chunks = 0